<template>
  <div style="margin-top: 24px; padding-bottom: 20px">
    <a-table
      :scroll="{ x: 500 }"
      :columns="columns"
      :data-source="list"
      class="nopaddingEstimateTable"
      :pagination="false"
      row-key="id"
      style="margin: -20px 0 0 0"
    >
      <template v-for="el in fixedArr" :slot="el" slot-scope="text,record">
        <span :key="el" v-if="record.name === '饲养周期'">{{ text ? Number(text).toFixed(0) : "-" }}</span>
        <span :key="el" v-else>{{ text ? Number(text).toFixed(2) : "-" }}</span>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  expectationEstimationColumns,
  expectationEstimationList,
  expectationEstimationListCopy,
} from "../../../../EstimateConfig/estimateConfig";
import { mapState } from "vuex";
export default {
  props: ["details","predictionType"],
  data() {
    return {
      property: "value",
      mode: 1,
      list: [],
      sectionList: [],
      expectationEstimationList,
      expectationEstimationListCopy,
      fixedArr: [],
      energySystemName: "",
    };
  },

  computed: {
    ...mapState("estimate", ["dataDictionary"]),
    columns() {
      let newColumns = this.dealColumns();
      return newColumns;
    },
  },
  watch: {
    details: {
      handler(data) {
        let { prediction } = data;
        this.getName()
        this.getDetails(prediction.id);
      },
      deep: true,
    },
  },
  methods: {
    dealColumns() {
      let newColumns = [...expectationEstimationColumns];

      let sectionLength = this.sectionList.length;
      this.sectionList.forEach((el, ind) => {
        if (this.mode === 0) {
          if (sectionLength > 1) {
            newColumns.push({
              title: el.name,
              dataIndex: `f${ind + 3}`,
              children: [
                {
                  title: "预估值",
                  dataIndex: `estimation${el.field}`,
                  scopedSlots: { customRender: `estimation${el.field}` },
                  width: 120,
                },
                {
                  title: "观测值",
                  dataIndex: `observation${el.field}`,
                  scopedSlots: { customRender: `observation${el.field}` },
                  width: 120,
                },
              ],
            });
          } else {
            newColumns.push({
              title: "预估值",
              dataIndex: `estimation${el.field}`,
              scopedSlots: { customRender: `estimation${el.field}` },
              width: 120,
            });
            newColumns.push({
              title: "观测值",
              dataIndex: `observation${el.field}`,
              scopedSlots: { customRender: `observation${el.field}` },
              width: 120,
            });
          }
        } else {
          if (sectionLength > 1) {
            newColumns.push({
              title: el.name,
              dataIndex: `f${ind + 3}`,
              children: [
                {
                  title: "预估值",
                  dataIndex: `estimation${el.field}`,
                  scopedSlots: { customRender: `estimation${el.field}` },
                  width: 120,
                },
              ],
            });
          } else {
            newColumns.push({
              title: "预估值",
              dataIndex: `estimation${el.field}`,
              scopedSlots: { customRender: `estimation${el.field}` },
              width: 120,
            });
          }
        }
      });
     
     return newColumns;
    },

    getDetails(id) {
      if (!id) return;
      this.sectionList = [];
      this.list = [];
      this.$http
        .get(
          `/sat-maximization/opweightrangeformula/subDetail?predictionId=${id}`
        )
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            //动态生成头部区间
            let sectionList = [];
            data.forEach((el) => {
              sectionList.push({
                name: `${el.initialBwforaa}-${el.finalBwforaa}kg`,
                field: `${el.initialBwforaa}-${el.finalBwforaa}`,
              });
              this.fixedArr.push(
                `estimation${el.initialBwforaa}-${el.finalBwforaa}`
              );
              this.fixedArr.push(
                `observation${el.initialBwforaa}-${el.finalBwforaa}`
              );
            });
            
            
            //table的数据部分
            let list = [];
            let array=[];
            
            //根据生长猪、教槽判断使用不同的数据
            if(this.predictionType=="growingFinishing"){
              array=this.expectationEstimationList
            }else{
              array=this.expectationEstimationListCopy
            }
            array.forEach((item) => {
              let obj = {
                name:
                  item.name.indexOf("能量体系名称") >= 0
                    ? item.name.replace(
                        "【能量体系名称】",
                        this.energySystemName
                      )
                    : item.name,
                unit: item.unit,
              };
              data.forEach((el) => {
                let dataBase = el.opWeightRangeFormula;
                obj[`estimation${el.initialBwforaa}-${el.finalBwforaa}`] =
                  dataBase[item.field1];
                obj[`observation${el.initialBwforaa}-${el.finalBwforaa}`] =
                  dataBase[item.field2];
              });
              list.push(obj);
            });

            this.list = [...list];
            this.sectionList = [...sectionList];
          }
        });
    },

    //能量体系名称
    getName() {
      let { prediction } = this.details;
      let { energySystem } = prediction;
      let obj = this.dataDictionary.EnergySystem.find(
        (el) => el.dictKey === energySystem
      );
      this.energySystemName = obj.dictValue.replace("体系", "") || " ";
    },
  },
};
</script>